import * as React from 'react';

import { useSurvey } from '@src/hooks/useSurvey';
import { SurveyQuestionProps } from './SurveyQuestion';

export interface TypeNumberProps extends SurveyQuestionProps {}

/**
 * @name TypeNumber
 * @description Basic HTML input for collecting a "number" like "age".
 */
export const TypeNumber = (props: TypeNumberProps) => {
  const { question } = props;

  // Hooks
  const { answers, setAnswer } = useSurvey();
  const value = answers[question.name];

  // Setup
  const {
    error_message,
    number_max: max,
    number_min: min,
    placeholder,
    properties = {},
    required = false
  } = question;
  const { autocomplete, pattern } = properties;

  // Handlers
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    event.currentTarget.setCustomValidity('');

    const isEmpty = event.target.value !== '';
    const value = isEmpty ? Number(event.target.value) : undefined;

    setAnswer(question.name, value);
  };

  return (
    <input
      autoComplete={autocomplete}
      className="m-0 rounded-none border-0 p-3 font-beatrice-light text-14 md:py-4 md:px-8 md:text-18"
      defaultValue={value}
      name={question.name}
      onChange={onChangeHandler}
      onInvalid={(event: React.FormEvent<HTMLInputElement>) => {
        if (error_message) event.currentTarget.setCustomValidity(error_message);
      }}
      max={max}
      min={min}
      pattern={pattern}
      placeholder={placeholder ?? ''}
      required={required}
      type="number"
    />
  );
};
